var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrow90DegDown = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.001,
    height: 11.501,
    viewBox: "0 0 10.001 11.501",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-90deg-down",
    transform: "translate(-3.5 14) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M2.646,9.646a.5.5,0,0,1,.708,0L6,12.293,8.646,9.646a.5.5,0,1,1,.708.708l-3,3a.5.5,0,0,1-.708,0l-3-3a.5.5,0,0,1,0-.708Z",
    fill: "#444a58",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M6,13a.5.5,0,0,1-.5-.5V6A2.5,2.5,0,0,1,8,3.5h5.5a.5.5,0,0,1,0,1H8A1.5,1.5,0,0,0,6.5,6v6.5A.5.5,0,0,1,6,13Z",
    fill: "#444a58",
    fillRule: "evenodd"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrow90DegDown);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMC4wMDEiIGhlaWdodD0iMTEuNTAxIiB2aWV3Qm94PSIwIDAgMTAuMDAxIDExLjUwMSI+CiAgPGcgaWQ9ImFycm93LTkwZGVnLWRvd24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zLjUgMTQpIHJvdGF0ZSgtOTApIj4KICAgIDxwYXRoIGlkPSJQYXRoXzg1IiBkYXRhLW5hbWU9IlBhdGggODUiIGQ9Ik0yLjY0Niw5LjY0NmEuNS41LDAsMCwxLC43MDgsMEw2LDEyLjI5Myw4LjY0Niw5LjY0NmEuNS41LDAsMSwxLC43MDguNzA4bC0zLDNhLjUuNSwwLDAsMS0uNzA4LDBsLTMtM2EuNS41LDAsMCwxLDAtLjcwOFoiIGZpbGw9IiM0NDRhNTgiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgogICAgPHBhdGggaWQ9IlBhdGhfODYiIGRhdGEtbmFtZT0iUGF0aCA4NiIgZD0iTTYsMTNhLjUuNSwwLDAsMS0uNS0uNVY2QTIuNSwyLjUsMCwwLDEsOCwzLjVoNS41YS41LjUsMCwwLDEsMCwxSDhBMS41LDEuNSwwLDAsMCw2LjUsNnY2LjVBLjUuNSwwLDAsMSw2LDEzWiIgZmlsbD0iIzQ0NGE1OCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CiAgPC9nPgo8L3N2Zz4K";